export const STORAGE_KEY = 'paylink';

export enum Mode {
  INITIALIZE = 1,
  PAYED,
}

export type ModeKey = keyof typeof Mode;

export type PaylinkStatus = { mode: Mode; url: string };

export const setStatus = ({ mode, url }: PaylinkStatus) => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(STORAGE_KEY, `${Mode[mode]}:${url}`);
  }
};

export const cleanupStatus = () => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(STORAGE_KEY);
  }
};

export const getStatus = (): PaylinkStatus | undefined => {
  if (typeof window !== 'undefined') {
    const entry = sessionStorage.getItem(STORAGE_KEY);
    const result = entry && /^([^:]+):(.*)$/g.exec(entry);

    if (!result) {
      return { mode: Mode.INITIALIZE, url: '' };
    }

    return {
      mode: Mode[result[1] as ModeKey],
      url: result[2],
    };
  }
  return { mode: Mode.INITIALIZE, url: '' };
};
